// export const BACKEND="http://20.195.8.233:8090"
// export const BACKEND="http://20.195.42.22:8090"
// export const BACKEND="http://103.175.217.209:8090"
export const BACKEND="https://backend.ceumonny.com"
// export const BACKEND="http://127.0.0.1:8090"

// export const BACKEND = process.env.REACT_APP_BACKEND;